import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import { VueSvgIconPlugin } from "@yzfe/vue3-svgicon";
import "@yzfe/svgicon/lib/svgicon.css";
import install from "./install";
import i18n from "./i18n";

createApp(App)
  .use(i18n)
  .use(install)
  .use(VueSvgIconPlugin, { tagName: "icon" })
  .use(store)
  .use(router)
  .mount("#app");
